import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const taskApi = createApi({
  reducerPath: 'taskApi',
  baseQuery: axiosBaseQuery({ baseUrl: process.env.REACT_APP_BASE_URL ?? '' }),
  tagTypes: ['TaskList', 'Task'],
  endpoints: () => ({})
})

export default taskApi
